import * as styles from './RoundButtonLink.css';
import { IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IRoundButtonLinkProps {
  url: string;
  onClick(): void;
}

export const RoundButtonLink = ({ url, onClick }: IRoundButtonLinkProps) => {
  return (
    <a href={url} target="_blank" onClick={onClick} className={styles['link']} rel="noreferrer">
      <IconActionArrowRight16 color="current_color" />
    </a>
  );
};
